import axios from '@/utils/axios'

/**
 * 登陆固定接口
 * 传递 code
 * 返回 登录态 + token
 */
export function loginApi (code) {
  return axios({
    url: '/Login/Login',
    method: 'post',
    data: {
      code: code
    }
  })
}
